import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import { useNavigate } from 'react-router-dom';
import API_CONFIG, { buildApiUrl, buildApiUrlWithParams } from '../config/api';

const DebtType = () => {
    const [debtTypes, setDebtTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [userGroups, setUserGroups] = useState([]);
    const [editingDebtType, setEditingDebtType] = useState(null);
    const [newDebtType, setNewDebtType] = useState({
        debt_type_desc: ''
    });
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            navigate('/login');
            return;
        }

        const decoded = JSON.parse(atob(token.split(".")[1]));
        setUserGroups(decoded["cognito:groups"]);

        fetchDebtTypes();
    }, [navigate]);

    const fetchDebtTypes = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(buildApiUrl(API_CONFIG.ENDPOINTS.DEBT_TYPES), {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const data = await response.json();
            setDebtTypes(data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching debt types:', error);
            setLoading(false);
        }
    };

    const handleEdit = (debtType) => {
        setEditingDebtType({ ...debtType });
    };

    const handleSave = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(buildApiUrl(API_CONFIG.ENDPOINTS.DEBT_TYPES), {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(editingDebtType)
            });

            if (response.ok) {
                setEditingDebtType(null);
                fetchDebtTypes();
            }
        } catch (error) {
            console.error('Error updating debt type:', error);
        }
    };

    const handleDelete = async (debtTypeId) => {
        if (window.confirm('Are you sure you want to delete this debt type?')) {
            try {
                const token = localStorage.getItem("token");
                const response = await fetch(buildApiUrlWithParams(API_CONFIG.ENDPOINTS.DEBT_TYPE_DETAIL, debtTypeId), {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                if (response.ok) {
                    fetchDebtTypes();
                }
            } catch (error) {
                console.error('Error deleting debt type:', error);
            }
        }
    };

    const handleAdd = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(buildApiUrl(API_CONFIG.ENDPOINTS.DEBT_TYPES), {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(newDebtType)
            });

            if (response.ok) {
                setNewDebtType({
                    debt_type_desc: ''
                });
                fetchDebtTypes();
            }
        } catch (error) {
            console.error('Error adding debt type:', error);
        }
    };

    const isFinance = userGroups.includes('mtkd-finance');

    if (loading) {
        return (
            <div className="container">
                <Navbar groups={userGroups}/>
                <div className="card">
                    <div className="card-body">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (!isFinance) {
        return (
            <div className="container">
                <Navbar groups={userGroups}/>
                <div className="card">
                    <div className="card-body">
                        <h2 className="text-danger">Access Denied</h2>
                        <p>You do not have permission to access this page.</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container">
            <Navbar groups={userGroups}/>
            <div className="card">
                <div className="card-body">
                    <h2 className="card-title">Debt Types</h2>
                    <div className="mb-3">
                        <h4>Add New Debt Type</h4>
                        <div className="row">
                            <div className="col-md-6">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Debt Type Description"
                                    value={newDebtType.debt_type_desc}
                                    onChange={(e) => setNewDebtType({ ...newDebtType, debt_type_desc: e.target.value })}
                                />
                            </div>
                            <div className="col-md-2">
                                <button className="btn btn-primary" onClick={handleAdd}>Add Debt Type</button>
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Description</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {debtTypes.map(debtType => (
                                    <tr key={debtType.debt_type_id}>
                                        <td>{debtType.debt_type_id}</td>
                                        <td>
                                            {editingDebtType && editingDebtType.debt_type_id === debtType.debt_type_id ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={editingDebtType.debt_type_desc}
                                                    onChange={(e) => setEditingDebtType({ ...editingDebtType, debt_type_desc: e.target.value })}
                                                />
                                            ) : (
                                                debtType.debt_type_desc
                                            )}
                                        </td>
                                        <td>
                                            {editingDebtType && editingDebtType.debt_type_id === debtType.debt_type_id ? (
                                                <button className="btn btn-success me-2" onClick={handleSave}>Save</button>
                                            ) : (
                                                <button className="btn btn-primary me-2" onClick={() => handleEdit(debtType)}>Edit</button>
                                            )}
                                            <button className="btn btn-danger" onClick={() => handleDelete(debtType.debt_type_id)}>Delete</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DebtType; 